






















import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Util } from '@/utils/Util';

@Component({
  components: {},
})
export default class FormSubmit extends Vue {
  @Prop({ required: false, type: String, default: () => '' })
  loadingLabel!: string;

  @Prop({ required: false, type: String })
  doneLabel!: string;

  @Prop({ required: true, type: Boolean })
  isLoading!: boolean;

  @Prop({ required: false, type: Boolean, default: () => false })
  isDone!: boolean;

  @Prop({ required: false, type: Number, default: () => 10 })
  delay!: number;

  async handleClick(evt: Event) {
    await Util.wait(this.delay);
    this.$emit('click', evt);
  }

  async handleSubmit(evt: Event) {
    await Util.wait(this.delay);
    this.$emit('submit', evt);
  }
}
